import { format } from "date-fns";
import { useAuthFetchQuery } from "@rentablo/api";
import { CACHE_KEYS, exchangeRates, lookup } from "@rentablo/api/apiv1";

export const useProposePrice = (
  tickerSymbol: string,
  quoteProvider: string,
  quoteCurrency: string,
  investmentCurrency: string,
  handleSecurityPriceChange: (quote: number) => void,
  handleExchangeRateChange: (rate: number) => void
) => {
  const lookupQuotes = useAuthFetchQuery(CACHE_KEYS.LOOKUP, lookup);
  const getExchangeRate = useAuthFetchQuery(
    CACHE_KEYS.EXCHANGE_RATES,
    exchangeRates
  );

  const proposeSecurityPriceChange = async (date: Date) => {
    if (!date || (date && isNaN(date.getTime()))) return;
    return lookupQuotes({
      tickerSymbol,
      quoteProvider,
      includeIndexes: false,
      quoteCurrency: quoteCurrency,
      convertToCurrency: investmentCurrency,
      from: format(date, "yyyy-MM-dd"),
      to: format(date, "yyyy-MM-dd"),
    })
      .then((result) => {
        const quotes =
          result.historicQuotes[
            `${tickerSymbol}${investmentCurrency ? `_${investmentCurrency}` : ""}`
          ];
        if (!quotes || !quotes.length) return;
        if (quotes[0].value == null) return;
        handleSecurityPriceChange(quotes[0].value);
      })
      .catch(() => {
        // ignore...
      });
  };

  const proposeExchangeRateChange = async (date: Date) => {
    if (!date || (date && isNaN(date.getTime()))) return;
    if (!investmentCurrency || investmentCurrency === "EUR") return;
    return getExchangeRate({
      from: "EUR",
      to: investmentCurrency,
      date: format(date, "yyyy-MM-dd"),
    })
      .then((result) => {
        if (!result || !result.rate) return;
        handleExchangeRateChange(result.rate);
      })
      .catch(() => {
        // ignore...
      });
  };

  return {
    proposeSecurityPriceChange,
    proposeExchangeRateChange,
  };
};
